import {
  ChangeDetectionStrategy,
  Component,
  input,
  viewChild,
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';

/** Base menu component for use with any component that is a menu and a menu trigger button. */
@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export abstract class BaseMenuComponent {
  /** Whether to hide the menu trigger button. If set to faluse you must create a button that triggers the @see {@link menu} */
  hideMenuTriggerButton = input<boolean>(false);
  /** Reference to the menu. */
  menu = viewChild.required<MatMenu>(MatMenu);
}
